export default __webpack_public_path__ + "static/androidAndIos-5adbdee4def0f0721e80302c62654a31.png";